var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',{staticClass:"berkah-main"},[_c('div',{attrs:{"id":"dashboard-core-view"}},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }